import { url } from '@seek/validators-js';
import { TextField as BraidTextField } from 'braid-design-system';
import { Controller, useFormContext } from 'react-hook-form';

import type { FormValues, SpecialTextFormFields } from '../types.ts';

interface UrlProps {
  element: SpecialTextFormFields;
}

export const Url = ({ element }: UrlProps) => {
  const { setValue } = useFormContext<FormValues>();

  return (
    <Controller
      key={element.id}
      name={element.id}
      rules={{
        required: element.required ? 'This field is required' : false,
        validate: element.required
          ? {
              validUrl: (value) =>
                url.test({
                  value,

                  validatorProps: undefined,
                  formValues: undefined,
                })
                  ? true
                  : 'Invalid URL',
            }
          : undefined,
      }}
      render={({ field, fieldState }) => (
        <BraidTextField
          label={element.label}
          placeholder={element.placeholder}
          secondaryLabel={element.secondaryLabel}
          onChange={field.onChange}
          type="url"
          value={field.value}
          message={fieldState.error?.message}
          tone={fieldState.invalid ? 'critical' : undefined}
          onClear={() => setValue(element.id, '')}
        />
      )}
    />
  );
};
